import React, { useEffect } from "react";
import CodePioneersTemplate from "../../Templetes/CodePioneers/CodePioneers.template";

const CodePioneersPage = () => {
  useEffect(() => {
    document.title = "Code Challenge - CodePioneers";
  }, []);
  return <CodePioneersTemplate />;
};

export default CodePioneersPage;